/**
 * Adobe Web SDK (Alloy) Types and Initialization
 * 
 * This file handles the initialization of Adobe Alloy SDK
 * and provides the configuration interface.
 */

import { initializeAlloy, isAlloyConfigured } from './alloy-loader';


/**
 * @param {Object} options 
 * @param {string} options.datastreamId 
 * @param {string} options.orgId 
 * @param {boolean} options.debugEnabled
 * @returns {Promise<void>}
 */
export async function initAnalytics(options = {}) {
  const config = {
    datastreamId: options.datastreamId || process.env.REACT_APP_ANALYTICS_DATASTREAM_ID || '',
    orgId: options.orgId || process.env.REACT_APP_ANALYTICS_ORG_ID || '',
    debugEnabled: options.debugEnabled ?? (process.env.NODE_ENV === 'development'),
  };

  if (!config.datastreamId || !config.orgId) {
    console.warn(
      'Analytics not fully configured. Please set REACT_APP_ANALYTICS_DATASTREAM_ID and REACT_APP_ANALYTICS_ORG_ID environment variables.'
    );
    return;
  }

  await initializeAlloy(config);
}

/**
 * @returns {Function|null} 
 */
export function getAlloy() {
  if (typeof window !== 'undefined' && window.alloy) {
    return window.alloy;
  }
  return null;
}


/**
 * @returns {boolean}
 */
 
export function isAlloyReady() {
  return isAlloyConfigured();
}
